import { createRoot } from "react-dom/client";
import App from "./App";
import theme from "./config/theme/baseTheme";
import { Provider } from "react-redux";
import store from "./config/redux/store";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { BrowserRouter } from "react-router-dom";
import { ErrorProvider } from "./contexts/ErrorContext"; // Import the ErrorProvider
import { setupGlobalAxiosInterceptors } from "./network/axiosInterceptors";

setupGlobalAxiosInterceptors();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element with id 'root'");
}
const root = createRoot(container);
root.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <Provider store={store}>
        <ErrorProvider>
        <CssBaseline />
        <App />
        </ErrorProvider>
      </Provider>
    </BrowserRouter>
  </ThemeProvider>
);
